import CloseIcon from '@mui/icons-material/Close';

const MaterialCloseIcon = () => {
  return <CloseIcon htmlColor="#1A1A1A" />;
};

export default MaterialCloseIcon;
